module.exports = "/_next/static/images/illustration-globe@2x-a00cadc23958bcf1484df19510978fd9.png";